import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import Highlighter from "react-highlight-words";
import FileUploadPopup from "../Project/ProjectSections/CandidateList/sections/UpdateVisaDetails/FileUploadPopup";
import CandidateErrorPopUp from "../Project/ProjectSections/CandidateList/CandidateErrorPopUp";

export default function ListDataFileManagerCandiate({
  candidateData = [],
  titles = [],
  loading,
}) {
  const [candidates, setCandidates] = useState(candidateData?.candidates);
  useEffect(() => {
    setCandidates(candidates);
  }, [candidateData]);
  console.log(candidates, "candidateData");
  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(candidates);

  const [searchWords, setSearchWords] = useState([]);

  const [bulkUploadPopupState, setBulkUploadPopupState] = useState({
    open: false,
  });
  const [showErrorPopUp, setShowErrorPopUp] = useState();
  return (
    <>
      {bulkUploadPopupState.open && (
        <FileUploadPopup
          popupState={bulkUploadPopupState}
          setPopupState={setBulkUploadPopupState}
          setShowErrorPopUp={setShowErrorPopUp}
          apiUrl="/dashboard/file-manager/candidate"
          setUpdatedCandidates={setCandidates}
        />
      )}
      {showErrorPopUp && (
        <CandidateErrorPopUp
          showErrorPopUp={showErrorPopUp}
          onToggle={() => setShowErrorPopUp(false)}
          title="Validation Error"
        />
      )}
      <div className="pt-2">
        <div className="flex flex-wrap  my-1 gap-3 items-center max-w-fit w-full">
          <Search
            searchKey={["candidate_id", "passport_number", "name"]}
            setSearchWords={setSearchWords}
          />
          <button
            className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-xs flex items-center gap-2"
            onClick={() => setBulkUploadPopupState({ open: true })}
          >
            <p>Upload File</p>
          </button>
        </div>
        <p className="text-sm w-full text-right font-medium mb-1  block">{`Slide / scroll to right >`}</p>
        <CountPerPage />
        <div
          className={`grid grid-cols-table-filemanager-candidates  gap-5 p-6 bg-white   w-full overflow-x-scroll lg:overflow-auto items-baseline  rounded-md `}
        >
          {titles.map((title, index) => (
            <p key={index} className="font-semibold uppercase">
              {title}
            </p>
          ))}
          {!loading && <NoDataFound className="col-span-full" />}
          {!loading &&
            currentList?.map((data, index) => (
              <React.Fragment key={index}>
                <PaginationIndex index={index} />
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={data?.candidate_id || "--"}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={data?.passport_number || "--"}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={data?.name || "--"}
                  />{" "}
                </p>
                {Object.keys(data?.candidate_file)?.map(
                  (fileDataKey, fileIndex) => {
                    if (
                      ![
                        "candidate_id",
                        "created_at",
                        "status",
                        "updated_at",
                        "id",
                      ].includes(fileDataKey)
                    ) {
                      return (
                        <div key={fileIndex}>
                          {data?.candidate_file[fileDataKey] ? (
                            <a
                              className="link link-hover"
                              target="_blank"
                              rel="noopener noreferrer"
                              href={data?.candidate_file[fileDataKey]}
                            >
                              View File
                            </a>
                          ) : (
                            <p>File not uploaded</p>
                          )}
                        </div>
                      );
                    } else return null;
                  }
                )}

                <hr className="border-[1.5px] border-slate-100  w-full col-span-full" />
              </React.Fragment>
            ))}
        </div>
        <Pagination />
      </div>
    </>
  );
}
